import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store/store';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { BrowserRouter, Routes, Route } from "react-router-dom"; // Import React Router
import App from './App';
//import TestDash from './test/TestDash';
import GuestDash from './guest/GuestDash';



const container = document.getElementById('root')!;
const root = createRoot(container);

  // Get Token Parameter from iframe url
 // let urlElements = window.location.search.substring(1) 
  //console.log(urlElements)

root.render(
    <Provider store={store}>
     
       <MantineProvider 
              theme={{
                globalStyles: (theme) => ({
                  '*, *::before, *::after': {
                    boxSizing: 'border-box',
                  },
                  body: {
                    ...theme.fn.fontStyles(),
                    backgroundColor: '#F6F6F8',
                    color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
                    lineHeight: theme.lineHeight,
                  },
                }),
                colors: {
                  'savdgreen': ['#c7d64f','#DFE3C5','#D5DCA5','#D0DA84','#D1E05E','#BECC52','#ABB74A','#939C4C','#7F854B','#6E7349'],
                  'savdgray': ['#F6F6F8','#DEDEDE','#C8C8C8','#B4B4B4','#A2A2A2','#929292','#838383','#838383','#868F96','#ffffff'],
                },
              
              }}
             withGlobalStyles 
             withNormalizeCSS>
                    <BrowserRouter>
                      <Notifications />
                      <Routes>
                           <Route path="/" element={<App />} />
                           <Route path="/meeting" element={<App />} />
                           <Route path="/setup" element={<App />} />
                           <Route path="/guest" element={<GuestDash />} /> 
                           {/**<Route path="/test" element={<TestDash />} /> */}
                         </Routes>
                    </BrowserRouter>
              
      </MantineProvider>
    
    </Provider>
);